var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonSidebarIssue.jinja');
require('./CommonSidebarIssue.less');

module.exports = Base.extend({

    template: template,


    initialize: function (options) {
        this.options = options || {};

        Base.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonSidebar/CommonSidebarIssue.js
// module id = 162
// module chunks = 0